module.exports = __webpack_public_path__ + "media/images/fr_ca/efficacy-segment-7159eeda65bed7dc9f862d92230713e9.jpg";